import React, { Component } from 'react'
import {
  Layout,
  Form,
  Input,
  Button,
  Breadcrumb,
  Select,
  Upload,
  DatePicker,
  message,
  TimePicker,
  Spin,
  Checkbox,
  Switch
} from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import './ImportSampleOrder.scss'
import HistoryTable from '../../components/HistoryTable/HistoryTable'
import { NavLink } from 'react-router-dom'
import { HTTPService } from '../../otherServices/apiService'
import moment from 'moment'
import {
  DATE_FORMAT,
  TIME_FORMAT,
  PERMISSIONS_BY_NAME,
  PAGE_LIMIT,
  USER_SORTING,
} from '../../otherServices/constant'
import { trimSpace, isPermission } from '../../otherServices/commonFunction'

const { Content } = Layout

const { Option } = Select

class ImportSampleOrder extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formData: null,
      loader: false,
      file: null,
      isDistributionData: false,
      users: [],
    }
    this.getFormData = this.getFormData.bind(this)
    this.handleFinish = this.handleFinish.bind(this)
  }

  //function to fetch form data
  componentDidMount() {
    this.getFormData()
  }
  async getFormData() {
    this.setState({ loader: true })
    const data = { ftp_purpose: this.props.ftp_purpose }
    try {
      let userRes = await HTTPService({
        method: 'GET',
        url: `ftp-detail/?ftp_purpose=${this.props.ftp_purpose}`,
      })
      if (userRes.success) {
        let startDate = moment(userRes.data.start_date)
        let starTime = moment(userRes.data.start_time, TIME_FORMAT)
        userRes.data.start_date = startDate
        userRes.data.start_time = starTime
        this.setState({
          formData: userRes.data,
        })
        this.setState({ loader: false })
      } else {
        message.error(userRes.message)
        this.setState({ loader: false })
      }
    } catch (error) {
      this.setState({ loader: false })
      message.error('Failed to Fetch')
    }
  }

  //function to submit form
  async handleFinish(values) {
    let valueData = trimSpace(values)
    let { manual_upload_file, ...otherData } = valueData
    this.setState({ loader: true })
    valueData.ftp_purpose = this.props.ftp_purpose
    let startDate = valueData.start_date
    let startTime = valueData.start_time
    valueData.start_date = moment(startDate).format(DATE_FORMAT)
    valueData.start_time = moment(startTime).format(TIME_FORMAT)
    valueData.dragger = ''
    valueData.ftp_url = valueData.ftp_url || ''
    valueData.manual_upload_file = this.state.file
    let formData = new FormData()
    for (let key in valueData) {
      formData.set(key, valueData[key])
    }
    try {
      let userRes = await HTTPService({
        method: 'POST',
        url: 'ftp-detail/save/',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      if (userRes.success) {
        this.getFormData()
        message.success('Form Submited Successfully')
      } else {
        this.setState({ loader: false })
        message.error(userRes.message)
      }
    } catch (error) {
      this.setState({ loader: false })
      message.error('Failed to Update', error)
    }
  }

  renderFields() {
    const ftp_purpose = this.props.ftp_purpose
    let archiveFolder
    let lableName2
    if (ftp_purpose === 'S4OrderAck') {
        archiveFolder = 'ftp_archive_folder' 
        lableName2 = 'S4 Order Ack Archive'
      }
      if (ftp_purpose === 'S4ShipAck') {
        archiveFolder = 'ftp_archive_folder' 
        lableName2 = 'S4 Ship Ack Archive'
      }
    return (
      <div className="formitem_row">
        <Form.Item
          label={lableName2}
          name={archiveFolder}
          rules={[
            {
              required: true,
              message: `Please input your ${lableName2} !`,
            },
          ]}
        >
          <Input placeholder={lableName2} size="large" />
        </Form.Item>
      </div>
    )
  }

  async handleChanges({ file, onSuccess }) {
    setTimeout(() => {
      onSuccess('ok')
    }, 0)
    this.setState({ file })
  }

  handleChange = (selectedItems) => {
    this.setState({ selectedItems })
  }

  onFinishFailed = (errors) => {
    
    message.error('Enter the required fields!')
  }

  renderForm() {
    const { selectedItems } = this.state
    const ftp_purpose = this.props.ftp_purpose
    const { users } = this.props
    return (
      <div className="ImportSampleOrderStyles">
        <div className="ImportSampleOrder_container">
          <div className="ImportSampleOrder__title">{this.props.tabTitle}</div>
          <div className="layout_content_box ImportSampleOrder_whitebox">
            <Form
              className="form_block_main import-sample-order-form"
              initialValues={this.state.formData}
              onFinish={this.handleFinish}
              onFinishFailed={this.onFinishFailed}
            >
              {this.renderFields()}
              <div className="formitem_row">
                <Form.Item
                  label="Username"
                  name="ftp_username"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your username!',
                    },
                  ]}
                >
                  <Input placeholder="John Doe" size="large" />
                </Form.Item>
                <Form.Item
                  name="email_output_to"
                  label="Select distribution List"
                  rules={[
                    {
                      required: true,
                      message: 'Please Select Dstribution group/ Enter MailID!',
                    },
                  ]}
                >
                  <Select
                    className="multiple_select"
                    mode="tags"
                    placeholder="Select Dstribution group or Enter MailID"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={selectedItems}
                    onChange={this.handleChange}
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option && option.children
                        ? option.children.indexOf(input.toLowerCase()) >= 0
                        : null
                    }
                    tokenSeparators={[',']}
                  >
                    {users.length &&
                      users.map((item) => (
                        <Select.Option key={item.name} value={item.name}>
                          {item.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="formitem_row">
                <Form.Item
                  label="Password"
                  name="ftp_password"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your email!',
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="********"
                    size="large"
                    type="password"
                  />
                </Form.Item>
                <Form.Item
                  label="Start Date"
                  name="start_date"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your email!',
                    },
                  ]}
                >
                  <DatePicker placeholder="YYYY-MM-DD" size="large" />
                </Form.Item>
              </div>
              <div className="formitem_row">
                <Form.Item
                  name="start_time"
                  label="Start Time"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your start_time!',
                    },
                  ]}
                >
                  <TimePicker placeholder="HH:mm:ss" size="large" />
                </Form.Item>
                <Form.Item
                  label="Frequency"
                  name="frequency"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your frequency!',
                    },
                  ]}
                >
                  <Select defaultValue="5 Min" style={{ width: '100%' }}>
                    <Option value="5">5 Min</Option>
                    <Option value="15">15 Min</Option>
                    <Option value="30">30 Min</Option>
                    <Option value="45">45 Min</Option>
                    <Option value="60">1 Hour</Option>
                    <Option value="120">2 Hour</Option>
                    <Option value="1440">1 day</Option>
                  </Select>
                </Form.Item>
              </div>
              <div className="formitem_row">
                   {ftp_purpose == 'ImportDKCoreReport' && (
                    <Form.Item
                    label="IDT DK Inventory Report Notification List"
                    name="IDTEmailNotifications"
                   
                    >
                     <Select
                    className="multiple_select"
                    mode="tags"
                    placeholder="Select Dstribution group or Enter MailID"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={selectedItems}
                    onChange={this.handleChange}
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option && option.children
                        ? option.children.indexOf(input.toLowerCase()) >= 0
                        : null
                    }
                    tokenSeparators={[',']}
                  >
                    {users.length &&
                      users.map((item) => (
                        <Select.Option key={item.name} value={item.name}>
                          {item.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
                   )}
                   {ftp_purpose == 'ImportDKCoreReport'
                  && (
                   <Form.Item
                   label="ISL DK Inventory Report Notification List"
                   name="ISLEmailNotifications"
                   
                   >
                    <Select
                   className="multiple_select"
                   mode="tags"
                   placeholder="Select Dstribution group or Enter MailID"
                   getPopupContainer={(triggerNode) => triggerNode.parentNode}
                   value={selectedItems}
                   onChange={this.handleChange}
                   style={{ width: '100%' }}
                   optionFilterProp="children"
                   filterOption={(input, option) =>
                     option && option.children
                       ? option.children.indexOf(input.toLowerCase()) >= 0
                       : null
                   }
                   tokenSeparators={[',']}
                 >
                   {users.length &&
                     users.map((item) => (
                       <Select.Option key={item.name} value={item.name}>
                         {item.name}
                       </Select.Option>
                     ))}
                 </Select>
                 </Form.Item>
                   )}
                   {ftp_purpose == 'ImportDKConsignReport' && (
                    <Form.Item
                    label="IDT DK Inventory Report Notification List"
                    name="IDTEmailNotifications"
                   
                    >
                     <Select
                    className="multiple_select"
                    mode="tags"
                    placeholder="Select Dstribution group or Enter MailID"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={selectedItems}
                    onChange={this.handleChange}
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option && option.children
                        ? option.children.indexOf(input.toLowerCase()) >= 0
                        : null
                    }
                    tokenSeparators={[',']}
                  >
                    {users.length &&
                      users.map((item) => (
                        <Select.Option key={item.name} value={item.name}>
                          {item.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
                   )}
                   {ftp_purpose == 'ImportDKConsignReport'
                  && (
                   <Form.Item
                   label="ISL DK Inventory Report Notification List"
                   name="ISLEmailNotifications"
                   
                   >
                    <Select
                   className="multiple_select"
                   mode="tags"
                   placeholder="Select Dstribution group or Enter MailID"
                   getPopupContainer={(triggerNode) => triggerNode.parentNode}
                   value={selectedItems}
                   onChange={this.handleChange}
                   style={{ width: '100%' }}
                   optionFilterProp="children"
                   filterOption={(input, option) =>
                     option && option.children
                       ? option.children.indexOf(input.toLowerCase()) >= 0
                       : null
                   }
                   tokenSeparators={[',']}
                 >
                   {users.length &&
                     users.map((item) => (
                       <Select.Option key={item.name} value={item.name}>
                         {item.name}
                       </Select.Option>
                     ))}
                 </Select>
                 </Form.Item>
                   )}
                   </div>
                   <div className="formitem_row">
                      {ftp_purpose == 'ImportDKConsignReport' 
                   && (
                      <Form.Item
                      label="REL DK Inventory Report Notification List"
                      name="RELEmailNotifications"
                     
                      >
                      <Select
                      className="multiple_select"
                      mode="tags"
                      placeholder="Select Dstribution group or Enter MailID"
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      value={selectedItems}
                      onChange={this.handleChange}
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option && option.children
                          ? option.children.indexOf(input.toLowerCase()) >= 0
                          : null
                      }
                      tokenSeparators={[',']}
                    >
                      {users.length &&
                        users.map((item) => (
                          <Select.Option key={item.name} value={item.name}>
                            {item.name}
                          </Select.Option>
                        ))}
                    </Select>
                    </Form.Item>
                )}
                {ftp_purpose == 'ImportDKCoreReport' 
                   && (
                      <Form.Item
                      label="REL DK Inventory Report Notification List"
                      name="RELEmailNotifications"
                      
                      >
                      <Select
                      className="multiple_select"
                      mode="tags"
                      placeholder="Select Dstribution group or Enter MailID"
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      value={selectedItems}
                      onChange={this.handleChange}
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option && option.children
                          ? option.children.indexOf(input.toLowerCase()) >= 0
                          : null
                      }
                      tokenSeparators={[',']}
                    >
                      {users.length &&
                        users.map((item) => (
                          <Select.Option key={item.name} value={item.name}>
                            {item.name}
                          </Select.Option>
                        ))}
                    </Select>
                    </Form.Item>
                )}
                  
                  {ftp_purpose == 'ImportDKCoreReport'
                   && (
                    <Form.Item
                    label="Email Notification Frequency"
                    name="email_notif_freq"
                    rules={[
                    {
                      required: true,
                      message: 'Please input your frequency!',
                    },
                  ]}
                    >
                    <Select  style={{ width: '100%' }}>
                    <Option value="60">1 Hour</Option>
                    <Option value="360">6 Hour</Option>
                    <Option value="720">12 Hour</Option>
                    <Option value="1440">daily</Option>
                  </Select>
                    </Form.Item>
                  )}
                  {ftp_purpose == 'ImportDKConsignReport'
                   && (
                    <Form.Item
                    label="Email Notification Frequency"
                    name="email_notif_freq"
                    rules={[
                    {
                      required: true,
                      message: 'Please input your frequency!',
                    },
                  ]}
                    >
                    <Select  style={{ width: '100%' }}>
                    <Option value="60">1 Hour</Option>
                    <Option value="360">6 Hour</Option>
                    <Option value="720">12 Hour</Option>
                    <Option value="1440">daily</Option>
                  </Select>
                    </Form.Item>
                  )}
              </div>
              <div className="formitem_row">
                <Form.Item name="ftp_url" label="URL">
                  <Input placeholder="Enter URL" type="text" />
                </Form.Item>
                {ftp_purpose == 'LogNoOrderAck' && (
                  <Form.Item
                    label=" Allowed delay in Hours"
                    name="allowed_delay"
                    rules={[
                      {
                        required: true,
                        message: 'Please input Allowed delay in Hours!',
                      },
                      // {
                      //     pattern: new RegExp(/^[0-9]$/),
                      //     message: 'Input number in requested format.',
                      //   }
                    ]}
                  >
                    <Input
                      placeholder="Enter Allowed delay in Hours"
                      type="number"
                      pattern="[0-9]"
                      step="1"
                    />
                  </Form.Item>
                )}
                {ftp_purpose == 'LogNoShipAck' && (
                  <Form.Item
                    label=" Allowed delay in Days"
                    name="allowed_delay"
                    rules={[
                      {
                        required: true,
                        message: 'Please input Allowed delay in Days!',
                      },
                      // {
                      //       pattern: new RegExp(/^[0-9]$/),
                      //       message: 'Input number in requested format.',
                      //     }
                    ]}
                  >
                    <Input
                      placeholder="Enter  Allowed delay in Days"
                      type="number"
                      pattern="[0-9]"
                      step="1"
                    />
                  </Form.Item>
                )}
              </div>
              <div className="formitem_row">
                <Form.Item
                  name="send_success_logs"
                  label="Send logs for success"
                  valuePropName="checked"
                >
                  <Checkbox> Send logs for success</Checkbox>
                </Form.Item>
                <Form.Item
                  name="api_to_s4"
                  label="Api To S4"
                  valuePropName="checked"
                  hidden={true}
                >
                  <Switch>Api To S4</Switch>
                </Form.Item>
              </div>
              <div className="formitem_upload_row">
                <Form.Item label="Sample Order File">
                  <Form.Item name="dragger">
                    <Upload.Dragger
                      customRequest={(info) => this.handleChanges(info)}
                      accept=".txt"
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        Click or drag file to this area to upload
                      </p>
                      <p className="ant-upload-hint">
                        Support for a single or bulk upload.
                      </p>
                    </Upload.Dragger>
                  </Form.Item>
                </Form.Item>
              </div>

              {isPermission(
                //check for save permission
                PERMISSIONS_BY_NAME['Manage FTP settings']
              ) && (
                <div className="formitem_action_row">
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button"
                      size="large"
                    >
                      Save
                    </Button>
                  </Form.Item>
                </div>
              )}
            </Form>
          </div>
        </div>
      </div>
    )
  }

  render() {
    // return this.state.loader ? (
    //   <div className="loader">
    //     <Spin />
    //   </div>
    // ) : this.state.formData ? (
    //   <div>{this.renderForm()}</div>
    // ) : <Spin />
    return this.state.loader ? (
      <div className="loader">
        <Spin />
      </div>
    ) : (
      <div>{this.renderForm()}</div>
    )
  }
}

export default ImportSampleOrder
